module.exports = __webpack_public_path__ + "img/join-banner.0c5408cc.png";